var _ellipse, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _ellipse7, _ellipse8, _ellipse9, _ellipse10, _ellipse11, _ellipse12, _ellipse13, _ellipse14, _ellipse15, _ellipse16, _ellipse17, _ellipse18, _ellipse19, _ellipse20, _ellipse21, _ellipse22, _ellipse23, _ellipse24, _ellipse25, _ellipse26, _ellipse27, _ellipse28, _ellipse29, _ellipse30, _ellipse31, _ellipse32, _ellipse33, _ellipse34, _ellipse35, _ellipse36, _ellipse37, _ellipse38, _ellipse39, _ellipse40, _ellipse41, _ellipse42, _ellipse43, _ellipse44, _ellipse45, _ellipse46, _ellipse47, _ellipse48, _ellipse49, _ellipse50, _ellipse51, _ellipse52, _ellipse53, _ellipse54, _ellipse55, _ellipse56, _ellipse57, _ellipse58, _ellipse59, _ellipse60, _ellipse61, _ellipse62, _ellipse63, _ellipse64, _ellipse65, _ellipse66, _ellipse67, _ellipse68, _ellipse69, _ellipse70, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSupportImage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 624,
    height: 463,
    viewBox: "0 0 624 463",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    rx: 3.59756,
    ry: 3.59435,
    transform: "matrix(-1 0 0 1 102.292 4.28625)",
    fill: "#D9D9D9"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 3.59756,
    ry: 3.59435,
    transform: "matrix(-1 0 0 1 102.292 27.2902)",
    fill: "#D9D9D9"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 3.59756,
    ry: 3.59435,
    transform: "matrix(-1 0 0 1 102.292 50.2941)",
    fill: "#D9D9D9"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 3.59756,
    ry: 3.59435,
    transform: "matrix(-1 0 0 1 102.292 73.298)",
    fill: "#D9D9D9"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 3.59756,
    ry: 3.59435,
    transform: "matrix(-1 0 0 1 102.292 96.3019)",
    fill: "#D9D9D9"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 3.59756,
    ry: 3.59435,
    transform: "matrix(-1 0 0 1 102.292 119.305)",
    fill: "#D9D9D9"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 3.59756,
    ry: 3.59435,
    transform: "matrix(-1 0 0 1 102.292 142.309)",
    fill: "#D9D9D9"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 3.59756,
    ry: 3.59435,
    transform: "matrix(-1 0 0 1 77.8287 4.28625)",
    fill: "#D9D9D9"
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 3.59756,
    ry: 3.59435,
    transform: "matrix(-1 0 0 1 77.8287 27.2902)",
    fill: "#D9D9D9"
  })), _ellipse10 || (_ellipse10 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 3.59756,
    ry: 3.59435,
    transform: "matrix(-1 0 0 1 77.8287 50.2941)",
    fill: "#D9D9D9"
  })), _ellipse11 || (_ellipse11 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 3.59756,
    ry: 3.59435,
    transform: "matrix(-1 0 0 1 77.8287 73.298)",
    fill: "#D9D9D9"
  })), _ellipse12 || (_ellipse12 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 3.59756,
    ry: 3.59435,
    transform: "matrix(-1 0 0 1 77.8287 96.3019)",
    fill: "#D9D9D9"
  })), _ellipse13 || (_ellipse13 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 3.59756,
    ry: 3.59435,
    transform: "matrix(-1 0 0 1 77.8287 119.305)",
    fill: "#D9D9D9"
  })), _ellipse14 || (_ellipse14 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 3.59756,
    ry: 3.59435,
    transform: "matrix(-1 0 0 1 77.8287 142.309)",
    fill: "#D9D9D9"
  })), _ellipse15 || (_ellipse15 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 3.59756,
    ry: 3.59435,
    transform: "matrix(-1 0 0 1 53.3653 4.28625)",
    fill: "#D9D9D9"
  })), _ellipse16 || (_ellipse16 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 3.59756,
    ry: 3.59435,
    transform: "matrix(-1 0 0 1 53.3653 27.2902)",
    fill: "#D9D9D9"
  })), _ellipse17 || (_ellipse17 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 3.59756,
    ry: 3.59435,
    transform: "matrix(-1 0 0 1 53.3653 50.2941)",
    fill: "#D9D9D9"
  })), _ellipse18 || (_ellipse18 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 3.59756,
    ry: 3.59435,
    transform: "matrix(-1 0 0 1 53.3653 73.298)",
    fill: "#D9D9D9"
  })), _ellipse19 || (_ellipse19 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 3.59756,
    ry: 3.59435,
    transform: "matrix(-1 0 0 1 53.3653 96.3019)",
    fill: "#D9D9D9"
  })), _ellipse20 || (_ellipse20 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 3.59756,
    ry: 3.59435,
    transform: "matrix(-1 0 0 1 53.3653 119.305)",
    fill: "#D9D9D9"
  })), _ellipse21 || (_ellipse21 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 3.59756,
    ry: 3.59435,
    transform: "matrix(-1 0 0 1 53.3653 142.309)",
    fill: "#D9D9D9"
  })), _ellipse22 || (_ellipse22 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 3.59756,
    ry: 3.59435,
    transform: "matrix(-1 0 0 1 28.902 4.28625)",
    fill: "#D9D9D9"
  })), _ellipse23 || (_ellipse23 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 3.59756,
    ry: 3.59435,
    transform: "matrix(-1 0 0 1 28.902 27.2902)",
    fill: "#D9D9D9"
  })), _ellipse24 || (_ellipse24 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 3.59756,
    ry: 3.59435,
    transform: "matrix(-1 0 0 1 28.902 50.2941)",
    fill: "#D9D9D9"
  })), _ellipse25 || (_ellipse25 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 3.59756,
    ry: 3.59435,
    transform: "matrix(-1 0 0 1 28.902 73.298)",
    fill: "#D9D9D9"
  })), _ellipse26 || (_ellipse26 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 3.59756,
    ry: 3.59435,
    transform: "matrix(-1 0 0 1 28.902 96.3019)",
    fill: "#D9D9D9"
  })), _ellipse27 || (_ellipse27 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 3.59756,
    ry: 3.59435,
    transform: "matrix(-1 0 0 1 28.902 119.305)",
    fill: "#D9D9D9"
  })), _ellipse28 || (_ellipse28 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 3.59756,
    ry: 3.59435,
    transform: "matrix(-1 0 0 1 28.902 142.309)",
    fill: "#D9D9D9"
  })), _ellipse29 || (_ellipse29 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 3.59756,
    ry: 3.59435,
    transform: "matrix(-1 0 0 1 4.43857 4.28625)",
    fill: "#D9D9D9"
  })), _ellipse30 || (_ellipse30 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 3.59756,
    ry: 3.59435,
    transform: "matrix(-1 0 0 1 4.43857 27.2902)",
    fill: "#D9D9D9"
  })), _ellipse31 || (_ellipse31 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 3.59756,
    ry: 3.59435,
    transform: "matrix(-1 0 0 1 4.43857 50.2941)",
    fill: "#D9D9D9"
  })), _ellipse32 || (_ellipse32 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 3.59756,
    ry: 3.59435,
    transform: "matrix(-1 0 0 1 4.43857 73.298)",
    fill: "#D9D9D9"
  })), _ellipse33 || (_ellipse33 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 3.59756,
    ry: 3.59435,
    transform: "matrix(-1 0 0 1 4.43857 96.3019)",
    fill: "#D9D9D9"
  })), _ellipse34 || (_ellipse34 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 3.59756,
    ry: 3.59435,
    transform: "matrix(-1 0 0 1 4.43857 119.305)",
    fill: "#D9D9D9"
  })), _ellipse35 || (_ellipse35 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 3.59756,
    ry: 3.59435,
    transform: "matrix(-1 0 0 1 4.43857 142.309)",
    fill: "#D9D9D9"
  })), _ellipse36 || (_ellipse36 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 3.59756,
    ry: 3.59435,
    transform: "matrix(-1 0 0 1 620.341 320.589)",
    fill: "#D9D9D9"
  })), _ellipse37 || (_ellipse37 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 3.59756,
    ry: 3.59435,
    transform: "matrix(-1 0 0 1 620.341 343.593)",
    fill: "#D9D9D9"
  })), _ellipse38 || (_ellipse38 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 3.59756,
    ry: 3.59435,
    transform: "matrix(-1 0 0 1 620.341 366.597)",
    fill: "#D9D9D9"
  })), _ellipse39 || (_ellipse39 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 3.59756,
    ry: 3.59435,
    transform: "matrix(-1 0 0 1 620.341 389.601)",
    fill: "#D9D9D9"
  })), _ellipse40 || (_ellipse40 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 3.59756,
    ry: 3.59435,
    transform: "matrix(-1 0 0 1 620.341 412.605)",
    fill: "#D9D9D9"
  })), _ellipse41 || (_ellipse41 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 3.59756,
    ry: 3.59435,
    transform: "matrix(-1 0 0 1 620.341 435.608)",
    fill: "#D9D9D9"
  })), _ellipse42 || (_ellipse42 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 3.59756,
    ry: 3.59435,
    transform: "matrix(-1 0 0 1 620.341 458.612)",
    fill: "#D9D9D9"
  })), _ellipse43 || (_ellipse43 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 3.59756,
    ry: 3.59435,
    transform: "matrix(-1 0 0 1 595.878 320.589)",
    fill: "#D9D9D9"
  })), _ellipse44 || (_ellipse44 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 3.59756,
    ry: 3.59435,
    transform: "matrix(-1 0 0 1 595.878 343.593)",
    fill: "#D9D9D9"
  })), _ellipse45 || (_ellipse45 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 3.59756,
    ry: 3.59435,
    transform: "matrix(-1 0 0 1 595.878 366.597)",
    fill: "#D9D9D9"
  })), _ellipse46 || (_ellipse46 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 3.59756,
    ry: 3.59435,
    transform: "matrix(-1 0 0 1 595.878 389.601)",
    fill: "#D9D9D9"
  })), _ellipse47 || (_ellipse47 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 3.59756,
    ry: 3.59435,
    transform: "matrix(-1 0 0 1 595.878 412.605)",
    fill: "#D9D9D9"
  })), _ellipse48 || (_ellipse48 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 3.59756,
    ry: 3.59435,
    transform: "matrix(-1 0 0 1 595.878 435.608)",
    fill: "#D9D9D9"
  })), _ellipse49 || (_ellipse49 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 3.59756,
    ry: 3.59435,
    transform: "matrix(-1 0 0 1 595.878 458.612)",
    fill: "#D9D9D9"
  })), _ellipse50 || (_ellipse50 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 3.59756,
    ry: 3.59435,
    transform: "matrix(-1 0 0 1 571.414 320.589)",
    fill: "#D9D9D9"
  })), _ellipse51 || (_ellipse51 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 3.59756,
    ry: 3.59435,
    transform: "matrix(-1 0 0 1 571.414 343.593)",
    fill: "#D9D9D9"
  })), _ellipse52 || (_ellipse52 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 3.59756,
    ry: 3.59435,
    transform: "matrix(-1 0 0 1 571.414 366.597)",
    fill: "#D9D9D9"
  })), _ellipse53 || (_ellipse53 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 3.59756,
    ry: 3.59435,
    transform: "matrix(-1 0 0 1 571.414 389.601)",
    fill: "#D9D9D9"
  })), _ellipse54 || (_ellipse54 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 3.59756,
    ry: 3.59435,
    transform: "matrix(-1 0 0 1 571.414 412.605)",
    fill: "#D9D9D9"
  })), _ellipse55 || (_ellipse55 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 3.59756,
    ry: 3.59435,
    transform: "matrix(-1 0 0 1 571.414 435.608)",
    fill: "#D9D9D9"
  })), _ellipse56 || (_ellipse56 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 3.59756,
    ry: 3.59435,
    transform: "matrix(-1 0 0 1 571.414 458.612)",
    fill: "#D9D9D9"
  })), _ellipse57 || (_ellipse57 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 3.59756,
    ry: 3.59435,
    transform: "matrix(-1 0 0 1 546.951 320.589)",
    fill: "#D9D9D9"
  })), _ellipse58 || (_ellipse58 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 3.59756,
    ry: 3.59435,
    transform: "matrix(-1 0 0 1 546.951 343.593)",
    fill: "#D9D9D9"
  })), _ellipse59 || (_ellipse59 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 3.59756,
    ry: 3.59435,
    transform: "matrix(-1 0 0 1 546.951 366.597)",
    fill: "#D9D9D9"
  })), _ellipse60 || (_ellipse60 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 3.59756,
    ry: 3.59435,
    transform: "matrix(-1 0 0 1 546.951 389.601)",
    fill: "#D9D9D9"
  })), _ellipse61 || (_ellipse61 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 3.59756,
    ry: 3.59435,
    transform: "matrix(-1 0 0 1 546.951 412.605)",
    fill: "#D9D9D9"
  })), _ellipse62 || (_ellipse62 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 3.59756,
    ry: 3.59435,
    transform: "matrix(-1 0 0 1 546.951 435.608)",
    fill: "#D9D9D9"
  })), _ellipse63 || (_ellipse63 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 3.59756,
    ry: 3.59435,
    transform: "matrix(-1 0 0 1 546.951 458.612)",
    fill: "#D9D9D9"
  })), _ellipse64 || (_ellipse64 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 3.59756,
    ry: 3.59435,
    transform: "matrix(-1 0 0 1 522.487 320.589)",
    fill: "#D9D9D9"
  })), _ellipse65 || (_ellipse65 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 3.59756,
    ry: 3.59435,
    transform: "matrix(-1 0 0 1 522.487 343.593)",
    fill: "#D9D9D9"
  })), _ellipse66 || (_ellipse66 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 3.59756,
    ry: 3.59435,
    transform: "matrix(-1 0 0 1 522.487 366.597)",
    fill: "#D9D9D9"
  })), _ellipse67 || (_ellipse67 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 3.59756,
    ry: 3.59435,
    transform: "matrix(-1 0 0 1 522.487 389.601)",
    fill: "#D9D9D9"
  })), _ellipse68 || (_ellipse68 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 3.59756,
    ry: 3.59435,
    transform: "matrix(-1 0 0 1 522.487 412.605)",
    fill: "#D9D9D9"
  })), _ellipse69 || (_ellipse69 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 3.59756,
    ry: 3.59435,
    transform: "matrix(-1 0 0 1 522.487 435.608)",
    fill: "#D9D9D9"
  })), _ellipse70 || (_ellipse70 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 3.59756,
    ry: 3.59435,
    transform: "matrix(-1 0 0 1 522.487 458.612)",
    fill: "#D9D9D9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M537.882 416.255C595.397 372.522 621.012 251.255 527.624 191.791C465.798 152.43 427.346 174.884 357.792 148.845C272.883 117.066 260.227 21.0506 156.945 68.2953C102.227 93.3165 64.296 163.838 57.6228 243.989C51.0829 322.48 78.9017 376.337 135.75 413.191C269.249 418.871 403.015 417.841 537.882 416.255Z",
    fill: "#DFF3FC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M301.598 71.3229C292.914 106.202 325.166 140.731 359.161 155.046C393.144 169.373 432.117 167.665 468.535 160.835C484.243 157.892 500.399 153.75 512.595 143.734C524.802 133.718 531.875 116.327 525.19 102.278C519.292 89.8889 504.916 83.5428 491.219 80.2849C477.521 77.0271 462.964 75.6949 450.768 68.8401C439.19 62.3365 430.979 51.5699 420.915 43.0438C402.312 27.3117 376.189 19.5123 352.004 24.4899C327.818 29.4675 308.985 41.6753 301.598 71.3229Z",
    fill: "#DFF3FC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M561.813 231.756V205.367H551.81C550.611 200.752 548.782 196.405 546.432 192.396L553.505 185.311L534.842 166.648L527.757 173.721C523.749 171.371 519.401 169.542 514.787 168.343V158.34H488.397V168.343C483.783 169.542 479.435 171.371 475.426 173.721L468.341 166.648L449.678 185.311L456.751 192.396C454.401 196.405 452.585 200.752 451.374 205.367H441.37V231.756H451.374C452.585 236.371 454.414 240.718 456.751 244.727L449.678 251.812L468.341 270.475L475.426 263.402C479.435 265.752 483.783 267.568 488.397 268.779V278.783H514.787V268.779C519.401 267.568 523.749 265.752 527.757 263.402L534.842 270.475L553.505 251.812L546.432 244.727C548.782 240.718 550.611 236.371 551.81 231.756H561.813ZM501.61 241.421C488.978 241.421 478.744 231.187 478.744 218.555C478.744 205.936 488.978 195.702 501.61 195.702C514.23 195.702 524.463 205.936 524.463 218.555C524.463 231.187 514.217 241.421 501.61 241.421Z",
    fill: "#A2C7EB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M482.087 297.87L477.061 284.778L472.096 286.679C470.618 284.62 468.886 282.816 466.961 281.266L469.116 276.409L456.315 270.705L454.147 275.561C451.713 275.162 449.206 275.077 446.687 275.356L444.785 270.39L431.706 275.428L433.607 280.394C431.548 281.871 429.744 283.603 428.194 285.529L423.337 283.373L417.633 296.174L422.489 298.342C422.09 300.776 422.017 303.283 422.283 305.803L417.318 307.704L422.344 320.796L427.309 318.894C428.787 320.953 430.519 322.758 432.444 324.308L430.289 329.165L443.09 334.869L445.258 330.012C447.692 330.412 450.199 330.485 452.718 330.218L454.62 335.184L467.711 330.158L465.81 325.192C467.869 323.715 469.673 321.983 471.224 320.057L476.08 322.213L481.784 309.412L476.928 307.244C477.328 304.809 477.412 302.302 477.134 299.783L482.087 297.87ZM454.062 314.123C447.801 316.521 440.777 313.396 438.367 307.135C435.969 300.873 439.093 293.849 445.355 291.451C451.616 289.053 458.64 292.178 461.038 298.439C463.448 304.688 460.312 311.725 454.062 314.123Z",
    stroke: "#A2C7EB",
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M439.202 251.969L435.811 243.128L432.456 244.412C431.463 243.02 430.289 241.796 428.981 240.755L430.446 237.473L421.799 233.621L420.333 236.903C418.686 236.637 416.991 236.576 415.295 236.77L414.011 233.416L405.17 236.807L406.454 240.161C405.061 241.154 403.838 242.329 402.797 243.637L399.515 242.172L395.663 250.819L398.945 252.284C398.679 253.931 398.618 255.615 398.812 257.323L395.458 258.606L398.849 267.447L402.203 266.163C403.209 267.556 404.371 268.779 405.679 269.821L404.214 273.103L412.861 276.954L414.326 273.672C415.973 273.939 417.657 273.999 419.364 273.805L420.648 277.16L429.489 273.769L428.205 270.414C429.598 269.409 430.821 268.247 431.863 266.939L435.145 268.404L438.996 259.757L435.714 258.291C435.981 256.644 436.041 254.949 435.848 253.253L439.202 251.969ZM420.273 262.954C416.046 264.577 411.299 262.458 409.676 258.231C408.053 254.004 410.172 249.257 414.399 247.634C418.626 246.011 423.373 248.13 424.996 252.357C426.619 256.584 424.5 261.331 420.273 262.954Z",
    stroke: "#A2C7EB",
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M436.126 97.1555C436.126 110.417 429.925 122.237 420.285 129.867C413.188 135.499 404.214 138.841 394.428 138.841C384.679 138.841 375.692 135.499 368.571 129.867C358.919 122.225 352.73 110.405 352.73 97.1555C352.73 74.1326 371.393 55.4575 394.428 55.4575C417.463 55.4575 436.126 74.1326 436.126 97.1555Z",
    fill: "#0097D8",
    stroke: "#0097D8",
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M396.123 96.9872C403.605 96.0638 408.921 89.2502 407.998 81.7686C407.074 74.287 400.261 68.9705 392.779 69.8939C385.297 70.8173 379.981 77.631 380.904 85.1126C381.828 92.5942 388.642 97.9106 396.123 96.9872Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M420.285 124.611C413.188 130.243 404.214 133.585 394.428 133.585C384.679 133.585 375.693 130.243 368.571 124.611C371.236 112.876 373.694 102.751 376.25 100.183C379.859 96.5742 389.438 94.479 394.416 94.479C399.394 94.479 409.434 97.0344 411.287 98.8874C415.065 102.654 418.323 113.057 420.285 124.611Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M334.515 199.929V179.34C334.515 173.721 339.069 169.167 344.688 169.167H409.554C415.174 169.167 419.728 173.721 419.728 179.34V199.929C419.728 205.548 415.174 210.102 409.554 210.102H344.7C339.081 210.114 334.515 205.548 334.515 199.929Z",
    fill: "#0097D8"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M361.91 198.851L330.519 229.431L381.397 203.72",
    fill: "#0097D8"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M342.387 178.831V178.722C342.387 177.887 343.065 177.208 343.901 177.208H375.971C376.807 177.208 377.485 177.887 377.485 178.722V178.831C377.485 179.667 376.807 180.345 375.971 180.345H343.901C343.065 180.345 342.387 179.667 342.387 178.831Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M378.926 178.831V178.722C378.926 177.887 379.604 177.208 380.44 177.208H408.428C409.264 177.208 409.942 177.887 409.942 178.722V178.831C409.942 179.667 409.264 180.345 408.428 180.345H380.44C379.604 180.345 378.926 179.667 378.926 178.831Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M366.706 185.722V185.613C366.706 184.778 367.384 184.1 368.22 184.1H408.428C409.264 184.1 409.942 184.778 409.942 185.613V185.722C409.942 186.558 409.264 187.236 408.428 187.236H368.22C367.384 187.236 366.706 186.558 366.706 185.722Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M342.387 185.722V185.613C342.387 184.778 343.065 184.1 343.901 184.1H361.862C362.697 184.1 363.375 184.778 363.375 185.613V185.722C363.375 186.558 362.697 187.236 361.862 187.236H343.901C343.065 187.236 342.387 186.558 342.387 185.722Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M372.289 192.614V192.505C372.289 191.669 372.967 190.991 373.803 190.991H408.428C409.264 190.991 409.942 191.669 409.942 192.505V192.614C409.942 193.449 409.264 194.127 408.428 194.127H373.803C372.967 194.127 372.289 193.449 372.289 192.614Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M342.387 192.614V192.505C342.387 191.669 343.065 190.991 343.901 190.991H367.82C368.656 190.991 369.334 191.669 369.334 192.505V192.614C369.334 193.449 368.656 194.127 367.82 194.127H343.901C343.065 194.127 342.387 193.449 342.387 192.614Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M342.387 199.505V199.396C342.387 198.56 343.065 197.882 343.901 197.882H352.778C353.614 197.882 354.292 198.56 354.292 199.396V199.505C354.292 200.34 353.614 201.019 352.778 201.019H343.901C343.065 201.019 342.387 200.34 342.387 199.505Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M357.429 199.505V199.396C357.429 198.56 358.107 197.882 358.943 197.882H408.428C409.264 197.882 409.942 198.56 409.942 199.396V199.505C409.942 200.34 409.264 201.019 408.428 201.019H358.943C358.107 201.019 357.429 200.34 357.429 199.505Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M174.406 170.789C183.752 150.702 175.046 126.843 154.96 117.496C134.874 108.15 111.014 116.856 101.668 136.942C92.3218 157.029 101.028 180.888 121.114 190.235C141.2 199.581 165.06 190.875 174.406 170.789Z",
    fill: "#0097D8"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M131.792 182.729C136.86 180.949 139.525 175.398 137.745 170.33C135.965 165.263 130.414 162.598 125.347 164.378C120.279 166.158 117.614 171.709 119.394 176.776C121.174 181.844 126.725 184.509 131.792 182.729Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M123.47 177.039L122.998 170.875L128.108 167.387L133.679 170.063L134.152 176.228L129.041 179.716L123.47 177.039Z",
    fill: "#0097D8"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M150.74 143.335C155.798 141.527 158.432 135.962 156.624 130.904C154.816 125.847 149.251 123.213 144.193 125.02C139.136 126.828 136.502 132.394 138.31 137.451C140.117 142.508 145.683 145.143 150.74 143.335Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M142.653 137.085L142.992 129.237L148.903 124.078L154.474 126.755L154.134 134.59L148.224 139.762L142.653 137.085Z",
    fill: "#0097D8"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M135.302 169.058L127.866 165.485L133.365 152.805C133.716 152.006 134.091 151.206 134.503 150.431L140.958 138.211L148.394 141.784L143.09 154.271C142.678 155.239 142.23 156.184 141.733 157.104L135.302 169.058Z",
    fill: "white"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M165.883 175.452C167.312 174.786 190.335 175.84 190.335 175.84L173.743 160.604L165.883 175.452Z",
    fill: "#0097D8"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M267.446 86.0445C276.089 66.0624 266.898 42.857 246.916 34.2136C226.934 25.5703 203.728 34.7621 195.085 54.7441C186.441 74.7262 195.633 97.9316 215.615 106.575C235.597 115.218 258.803 106.027 267.446 86.0445Z",
    fill: "#0097D8"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M232.589 36.7944H229.961V69.9057H232.589V36.7944Z",
    fill: "white"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M202.188 89.0228L203.684 91.1836L231.277 72.0849L229.781 69.9241L202.188 89.0228Z",
    fill: "white"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M234.903 70.3901C234.903 72.3884 233.28 74.0234 231.27 74.0234C229.271 74.0234 227.636 72.4005 227.636 70.3901C227.636 68.3918 229.259 66.7568 231.27 66.7568C233.28 66.7568 234.903 68.3918 234.903 70.3901Z",
    fill: "white"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M338.306 337.339C335.969 301.297 351.737 263.995 378.296 242.656C379.12 278.88 363.509 315.539 338.306 337.339Z",
    fill: "#73DF1E"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M373.961 252.356C362.77 273.211 353.094 295.035 345.052 317.55C335.278 344.884 327.588 373.926 310.851 396.84",
    stroke: "#62D11E",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M329.925 360.011C343.368 329.939 370.049 307.219 399.466 300.788C386.944 333.015 358.774 357.6 329.925 360.011Z",
    fill: "#73DF1E"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M392.248 307.413C372.156 325.095 351.725 342.28 330.955 358.957",
    stroke: "#62D11E",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M321.993 386.207C339.953 359.381 373.089 345.381 400.508 353.035C380.343 379.521 347.135 393.558 321.993 386.207Z",
    fill: "#73DF1E"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M393.932 354.973C370.388 369.7 344.991 380.575 318.808 387.115",
    stroke: "#62D11E",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M331.694 350.891C337.434 320.686 328.823 287.018 309.652 264.746C301.792 294.43 309.288 329.213 331.694 350.891Z",
    fill: "#73DF1E"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M311.626 272.449C315.405 300.546 322.126 326.863 332.542 352.587",
    stroke: "#62D11E",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M321.835 376.615C319.389 345.562 303.475 316.399 280.198 300.304C281.542 316.75 285.914 332.604 292.854 347.016C300.835 363.571 312.558 374.071 321.835 376.615Z",
    fill: "#73DF1E"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M283.649 306.589C292.805 332.483 305.982 356.486 322.417 377.269",
    stroke: "#62D11E",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M501.598 369.167C514.302 336.116 543.526 309.302 575.753 301.14C561.632 333.742 532.808 360.023 501.598 369.167Z",
    fill: "#73DF1E"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M567.941 308.006C549.509 322.019 531.996 337.509 515.671 354.282C495.833 374.653 477.122 397.373 452.936 410.961",
    stroke: "#62D11E",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M484.897 385.94C509.107 364.637 542 355.287 570.63 361.561C546.36 385.165 511.384 395.568 484.897 385.94Z",
    fill: "#73DF1E"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M561.535 364.528C536.526 372.085 511.42 379.049 486.229 385.431",
    stroke: "#62D11E",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M467.142 406.044C494.016 389.477 529.041 390.53 550.138 408.539C521.46 423.896 486.35 422.842 467.142 406.044Z",
    fill: "#73DF1E"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M543.538 407.57C516.7 411.083 489.778 410.404 463.969 405.548",
    stroke: "#62D11E",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M490.201 378.54C507.653 353.979 513.842 320.469 506.03 292.807C486.907 316.036 479.277 350.08 490.201 378.54Z",
    fill: "#73DF1E"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M504.613 300.461C496.426 327.033 491.594 353.217 490.262 380.394",
    stroke: "#62D11E",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M470.945 397.434C481.506 368.779 479.398 336.298 465.422 312.463C459.876 327.663 457.235 343.564 457.465 359.236C457.72 377.233 463.775 391.378 470.945 397.434Z",
    fill: "#73DF1E"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M465.883 319.463C463.364 346.265 465.168 373.03 471.175 398.245",
    stroke: "#62D11E",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M141.54 311.385C128.593 271.771 92.4418 239.761 50.4048 230.678C68.0746 264.952 100.132 292.226 141.54 311.385Z",
    fill: "#73DF1E"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M143.732 317.526C115.356 301.491 79.8102 297.954 49 308.091C77.5818 322.37 111.444 326.342 143.732 317.526Z",
    fill: "#73DF1E"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M151.58 326.125C120.915 321.874 88.8088 329.431 63.9087 346.762C92.1393 357.02 126.014 350.359 151.58 326.125Z",
    fill: "#73DF1E"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M161.135 344.885C130.773 344.763 100.919 359.188 83.0679 382.622C96.5837 385.335 110.935 383.712 123.325 378.093C135.726 372.485 146.117 362.906 161.135 344.885Z",
    fill: "#73DF1E"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M182.547 376.288C152.609 371.153 120.709 380.43 99.1152 400.558C112.001 405.451 126.425 406.238 139.614 402.763C152.791 399.275 164.672 391.56 182.547 376.288Z",
    fill: "#73DF1E"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M150.223 313.263C130.458 286.619 125.093 250.71 136.32 220.154C144.894 234.675 152.294 250.032 155.746 266.357C159.198 282.683 158.531 300.086 150.223 313.263Z",
    fill: "#73DF1E"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M162.298 338.974C157.611 310.659 167.3 280.66 187.743 260.156C190.093 289.44 181.131 319.282 162.298 338.974Z",
    fill: "#73DF1E"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M59.5972 237.775C119.764 276.276 166.827 333.658 191.667 398.863",
    stroke: "#62D11E",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M138.185 234.203C145.5 263.923 149.957 294.261 151.459 324.696",
    stroke: "#62D11E",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M183.25 271.649C180.852 295.629 173.44 319.064 161.607 340.173",
    stroke: "#62D11E",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M61.668 308.782C89.2567 314.026 117.294 316.872 145.342 317.284",
    stroke: "#62D11E",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M78.2842 344.4C103.717 342.547 128.75 336.395 151.882 326.27",
    stroke: "#62D11E",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M93.5322 378.347C117.003 366.636 140.474 354.913 163.945 343.213",
    stroke: "#62D11E",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M108.792 399.02C139.433 393.11 148.54 386.05 182.548 376.288",
    stroke: "#62D11E",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M302.797 342.886C302.797 342.886 305.449 367.193 308.416 369.143C313.721 372.643 375.123 380.733 375.123 380.733L373.113 396.707C373.113 396.707 289.015 404.264 285.442 400.062C279.241 392.771 268.341 357.601 268.341 357.601L302.797 342.886Z",
    fill: "#E06A58"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M262.25 280.309L269.044 263.996C269.044 263.996 287.477 272.655 293.556 283.349C300.06 294.782 308.017 355.566 308.017 355.566C308.017 355.566 275.475 363.063 269.492 359.878C263.509 356.693 262.25 280.309 262.25 280.309Z",
    fill: "#BE22E4"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M210.499 204.592C205.74 202.848 200.702 201.322 195.603 201.709C190.504 202.097 185.296 204.797 183.565 209.279C182.329 212.452 182.898 216.194 180.949 219.052C179.084 221.789 175.378 222.928 171.914 223.158C168.438 223.4 164.938 222.94 161.486 223.388C150.829 224.805 143.223 236.383 146.723 245.866C148.116 249.644 150.974 253.253 150.32 257.189C149.63 261.404 145.209 264.177 143.393 268.089C140.983 273.297 143.865 279.607 148.625 283.155C153.384 286.692 159.573 288.036 165.58 288.932C173.852 290.167 182.39 290.749 190.565 289.005C198.74 287.261 206.551 282.949 210.778 276.216C212.655 273.236 213.793 269.87 215.973 267.072C220.479 261.295 228.46 259.054 234.745 254.961C241.612 250.468 246.65 241.724 242.605 234.881C238.706 228.305 228.557 226.839 224.487 220.36C222.804 217.684 222.404 214.498 221.314 211.58C220.2 208.649 217.536 207.171 210.499 204.592Z",
    fill: "#0A2240"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M238.234 285.262C239.433 286.643 240.85 288.157 242.811 288.29C244.882 288.435 246.614 286.97 247.947 285.553C254.826 278.274 259.367 269.337 261.208 260.12C259.5 259.151 257.853 258.219 256.364 257.347C254.983 256.523 253.941 255.373 253.348 254.028C252.936 253.035 252.791 251.994 252.9 250.904C253.869 241.796 254.729 236.722 257.926 227.481C242.739 224.054 228.412 219.984 220.176 213.105C219.171 217.344 217.984 225.64 215.453 233.864C212.752 242.571 208.538 251.182 201.392 254.888C215.417 263.172 227.927 273.466 238.234 285.262Z",
    fill: "#F9A07B"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M252.9 250.916C252.791 252.006 252.936 253.06 253.348 254.041C244.362 264.94 224.27 250.698 215.453 233.876C217.984 225.652 219.171 217.357 220.176 213.118C228.4 219.997 242.739 224.078 257.926 227.493C254.729 236.734 253.869 241.796 252.9 250.916Z",
    fill: "#E06A58"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M277.921 382.683C275.935 395.835 290.129 409.993 290.48 417.017C260.336 417.017 197.19 418.858 165.035 414.486C163.57 406.372 179.447 388.121 179.447 370.099C179.447 367.714 179.35 365.098 179.156 362.288C178.648 354.246 177.461 344.679 176.141 334.869C172.556 308.552 167.784 280.406 171.308 274.568C178.212 263.196 194.356 255.469 202.361 252.151C205.11 251.013 206.903 250.395 207.036 250.322C217.076 267.447 237.507 282.053 245.222 281.399C247.365 281.229 253.723 279.013 257.926 257.855C259.561 258.788 261.196 259.648 262.819 260.483C270.8 264.637 278.284 268.065 280.44 273.406C286.132 287.467 291.715 322.915 290.48 335.523C289.233 348.239 284.122 357.952 280.537 370.717C279.701 373.708 278.938 376.882 278.321 380.297C278.163 381.06 278.042 381.859 277.921 382.683Z",
    fill: "#D739FF"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M290.48 417.017C260.336 417.017 197.19 418.858 165.035 414.486C163.57 406.372 179.447 388.12 179.447 370.099C179.447 367.713 179.35 365.097 179.156 362.288C178.648 354.246 177.461 344.678 176.141 334.869C181.845 340.888 190.165 315.455 193.847 322.903C213.769 363.111 229.477 373.684 256.775 373.684C264.914 373.684 272.423 372.558 280.537 370.717C279.701 373.708 278.938 376.881 278.321 380.297C278.175 381.072 278.042 381.871 277.921 382.695C275.935 395.823 290.129 409.981 290.48 417.017Z",
    fill: "#C333E7"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M262.819 260.483C261.523 269.894 257.684 282.574 246.517 285.916C231.427 290.434 209.591 262.239 202.361 252.151C205.11 251.013 206.902 250.395 207.036 250.322C217.076 267.447 237.507 282.053 245.221 281.399C247.365 281.229 253.723 279.013 257.926 257.855C259.561 258.776 261.196 259.636 262.819 260.483Z",
    fill: "#AB26CC"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M269.019 402.859L268.91 413.36L456.63 414.474L457.017 402.569L269.019 402.859Z",
    fill: "#325F73"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M537.991 309.181L533.813 304.943L397.08 304.046L328.484 403.247L332.069 406.129L537.991 309.181Z",
    fill: "#325F73"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M399.721 307.716L332.069 406.129L461.293 406.771L537.991 309.181L399.721 307.716Z",
    fill: "#0B2D50"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M432.371 370.535C440.679 370.535 447.413 367.168 447.413 363.015C447.413 358.861 440.679 355.494 432.371 355.494C424.064 355.494 417.33 358.861 417.33 363.015C417.33 367.168 424.064 370.535 432.371 370.535Z",
    fill: "#3C738C"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M299.116 215.654C301.247 204.219 296.86 193.81 289.318 192.404C281.776 190.999 273.934 199.129 271.803 210.565C269.672 222 274.059 232.409 281.601 233.814C289.144 235.22 296.985 227.089 299.116 215.654Z",
    fill: "#56C4F9"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M299.127 179.764C297.722 189.719 293.278 200.691 286.798 212.815C284.521 202.884 283.068 190.785 281.058 178.686C279.011 166.563 276.407 154.44 271.89 144.533C270.872 142.341 269.77 140.246 268.571 138.308C271.248 138.054 273.961 138.308 276.54 139.023C280.573 140.1 284.352 142.184 287.44 144.969C292.575 149.535 296.015 155.76 298.061 162.324C299.745 167.774 300.048 173.563 299.127 179.764Z",
    fill: "#0B2D50"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M291.521 190.058C291.449 192.02 291.316 194.019 291.134 196.005C288.373 228.22 274.845 250.322 254.147 250.322C224.923 250.322 205.982 217.55 205.982 185.444C205.982 153.774 225.384 130.848 248.092 133.5C261.184 135.002 270.751 139.35 277.545 145.72C282.039 149.959 285.284 155.082 287.501 160.907C290.032 167.435 291.255 174.823 291.509 182.78C291.509 182.804 291.534 182.828 291.534 182.852C291.63 185.202 291.606 187.6 291.521 190.058Z",
    fill: "#F9A07B"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M291.522 190.058C290.65 186.946 289.354 183.906 287.586 181.181C270.352 190.191 249.812 193.667 230.337 190.373C226.631 193.461 223.01 196.501 219.365 199.541C219.437 184.887 219.643 174.968 225.36 167.871C230.725 161.21 239.675 158.703 248.152 157.613C257.696 156.365 267.397 156.414 276.916 157.795C280.561 158.303 284.34 159.09 287.513 160.931C290.044 167.459 291.267 174.847 291.522 182.804C291.522 182.828 291.546 182.852 291.546 182.876C291.631 185.202 291.606 187.6 291.522 190.058Z",
    fill: "#E06A58"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M295.736 170.221C291.727 173.612 286.701 176.421 281.058 178.698C264.999 185.178 244.132 187.321 227.867 186.534C219.873 204.095 216.64 210.393 214.593 225.713C206.781 218.386 200.423 204.967 198.534 194.418C196.669 183.906 196.85 172.873 199.781 162.542C204.396 146.253 216.034 137.533 224.1 133.294C226.11 132.192 227.927 131.429 229.332 130.872C239.638 126.888 251.253 127.251 261.826 130.485C267.59 132.277 272.447 135.305 276.528 139.035C284.776 146.483 289.875 156.572 293.169 164.129C294.21 166.442 295.046 168.537 295.736 170.221Z",
    fill: "#0B2D50"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M299.127 179.764C298.461 176.24 297.468 172.824 296.063 169.53C295.276 167.665 294.307 165.861 293.181 164.117C289.511 158.352 284.17 153.604 277.715 151.509C275.874 148.93 273.936 146.604 271.902 144.545C264.575 137.097 255.976 132.834 246.868 131.344C239.287 130.121 231.403 130.812 224.124 133.282C226.134 132.18 227.951 131.417 229.356 130.86C239.662 126.876 251.277 127.239 261.85 130.472C267.614 132.265 272.471 135.293 276.552 139.023C280.585 140.101 284.364 142.184 287.452 144.969C292.587 149.535 296.027 155.76 298.073 162.324C299.745 167.774 300.047 173.563 299.127 179.764Z",
    fill: "#225570"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M237.18 199.517C242.581 196.429 248.189 195.036 256.049 197.906",
    stroke: "#0B2D50",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M274.167 199.299C278.793 195.847 285.648 195.496 289.22 199.299",
    stroke: "#0B2D50",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M268.583 216.908C269.056 219.355 268.801 224.768 267.639 227.202",
    stroke: "#CC454E",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M250.332 218.555C251.563 218.555 252.56 216.983 252.56 215.043C252.56 213.103 251.563 211.531 250.332 211.531C249.101 211.531 248.104 213.103 248.104 215.043C248.104 216.983 249.101 218.555 250.332 218.555Z",
    fill: "#262D40"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M279.459 216.92C280.69 216.92 281.687 215.348 281.687 213.408C281.687 211.468 280.69 209.896 279.459 209.896C278.228 209.896 277.23 211.468 277.23 213.408C277.23 215.348 278.228 216.92 279.459 216.92Z",
    fill: "#262D40"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M265.822 231.986C265.822 231.986 265.386 232.834 264.55 233.984C263.243 235.74 261.014 238.163 257.974 239.107H257.962C256.678 239.519 255.286 239.664 253.735 239.386C249.182 238.574 247.983 234.372 247.765 231.138C247.716 230.509 247.716 229.927 247.728 229.394C247.753 228.086 247.898 227.214 247.898 227.214C255.152 231.211 265.822 231.986 265.822 231.986Z",
    fill: "#CC454E"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M265.822 231.986C265.822 231.986 265.386 232.834 264.551 233.984C260.845 233.936 253.263 232.035 247.729 229.394C247.753 228.086 247.898 227.214 247.898 227.214C255.153 231.211 265.822 231.986 265.822 231.986Z",
    fill: "white"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M257.962 239.095C256.678 239.507 255.286 239.652 253.735 239.374C249.182 238.562 247.983 234.36 247.765 231.126C249.969 231.392 252.1 232.24 253.869 233.584C255.722 235.001 257.139 236.927 257.962 239.095Z",
    fill: "#E8729B"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M214.666 193.958C214.666 193.958 214.411 178.856 220.697 163.85C228.581 145.018 244.652 136.964 260.239 136.419C279.023 135.753 290.783 148.36 290.783 148.36C290.783 148.36 284.667 137.57 272.604 134.469C264.684 132.434 252.73 132.107 243.138 136.007C233.256 140.016 220.939 151.146 216.482 162.906C212.037 174.665 209.87 192.977 209.87 192.977L214.666 193.958Z",
    fill: "#3D86E0"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M214.348 233.277C222.391 232.441 227.884 221.883 226.617 209.696C225.35 197.508 217.802 188.306 209.759 189.142C201.716 189.978 196.223 200.536 197.49 212.724C198.757 224.911 206.305 234.113 214.348 233.277Z",
    fill: "#56C4F9"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M210.648 229.368C215.84 228.587 218.937 220.55 217.564 211.415C216.191 202.281 210.869 195.508 205.677 196.288C200.485 197.069 197.388 205.106 198.761 214.241C200.133 223.375 205.455 230.148 210.648 229.368Z",
    fill: "#3D86E0"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M260.36 250.771C264.668 250.771 268.159 248.596 268.159 245.914C268.159 243.232 264.668 241.058 260.36 241.058C256.052 241.058 252.561 243.232 252.561 245.914C252.561 248.596 256.052 250.771 260.36 250.771Z",
    fill: "#3A92C9"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M221.181 229.673C221.181 229.673 232.638 244.4 252.561 245.914",
    stroke: "#3A92C9",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M268.91 374.823L268.16 394.189C268.16 394.189 198.122 415.177 186.556 408.54C180.912 405.294 175.644 387.443 171.708 370.015C167.59 351.703 164.95 333.876 164.95 333.876L206.006 325.834C206.006 325.834 206.03 350.868 207.423 365.34C207.92 370.73 208.634 374.654 209.591 375.296C213.212 377.681 268.91 374.823 268.91 374.823Z",
    fill: "#F9A07B"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M207.423 365.316C199.963 367.738 185.563 371.48 171.708 370.003C167.59 351.691 164.95 333.864 164.95 333.864L206.006 325.822C206.006 325.81 206.03 350.843 207.423 365.316Z",
    fill: "#E06A58"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M266.912 375.017C277.327 372.788 294.961 367.435 302.276 365.595C307.472 364.287 320.999 371.287 324.572 377.887C326.134 380.77 327.612 397.095 322.198 395.412C319.486 394.564 319.934 387.564 319.086 384.706C318.396 382.38 316.191 380.128 312.837 378.19C315.077 383.773 314.992 388.642 314.75 394.673C314.702 396.005 314.617 397.398 313.975 398.548C313.321 399.699 311.916 400.522 310.705 400.014C309.47 399.505 309.046 397.967 308.767 396.623C307.811 391.972 306.842 387.322 306.454 382.065C306.551 387.237 306.442 392.42 306.115 397.58C305.873 401.528 303.911 403.696 301.501 403.005C300.423 402.702 299.987 401.709 299.527 400.401C298.8 402.933 296.983 405.73 294.634 404.664C293.205 404.023 292.321 398.863 292.575 393.559C288.07 396.356 282.983 397.543 277.122 397.81C271.865 398.052 266.488 397.071 263.327 393.498C263.642 387.915 265.483 379.655 266.912 375.017Z",
    fill: "#F9A07B"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M299.635 399.602C299.987 395.412 299.623 391.161 298.558 387.116",
    stroke: "#CC454E",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M201.392 285.214C198.413 276.821 187.501 259.648 187.501 259.648C187.501 259.648 170.848 266.575 164.938 278.335C154.935 298.246 160.021 355.409 160.021 355.409C173.501 361.053 200.556 361.138 212.074 359.515C212.074 359.515 207.363 301.988 201.392 285.214Z",
    fill: "#DD54FF"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M203.512 288.727C208.053 310.466 210.488 330.739 211.263 350.601",
    stroke: "#BE22E4",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M559.936 411.022H82.4263V423H559.936V411.022Z",
    fill: "#0B2D50"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupportImage);
export default __webpack_public_path__ + "static/media/supportImage.c9ea39c75a4f709e1ba4d4ae5b57dbb9.svg";
export { ForwardRef as ReactComponent };